export default __webpack_public_path__ + "static/media/img-empty.1f2f82db.png";